<template>
  <v-layout>
    <v-flex xs12>
      <v-container fluid grid-list-xl>
        <v-card>

          <v-stepper v-model="step">
            <v-stepper-header>
              <v-stepper-step step="1" :complete="step > 1">
                Select Import
                <small v-if="importEntity">{{importEntity | capitalize}}</small>
              </v-stepper-step>
              <v-divider></v-divider>
              <v-stepper-step step="2" :complete="step > 2">
                File
                <small v-if="file">{{file.name}}</small>
              </v-stepper-step>
              <v-divider></v-divider>
              <v-stepper-step step="3" :complete="step > 3" :rules="[() => !this.error ]">Result</v-stepper-step>
            </v-stepper-header>
            
            <v-stepper-items>
              <v-stepper-content step="1" class="text-center">
                <p>Please choose if you want to Import Customers or Contacts.</p>
                <v-btn color="success" @click.native="chooseImportEntity('customers')">Customers</v-btn>
                <v-btn color="success" @click.native="chooseImportEntity('contacts')">Contacts</v-btn>
              </v-stepper-content>
              
              <v-stepper-content step="2" class="text-center">
                <p>Upload the CSV file containing your {{importEntity}}:</p>
                <p>
                  <input type="file" accept="text/csv, application/vnd.ms-excel" @change="chooseFile">
                </p>
                <p>
                  <v-btn color="success" :disabled="!file" @click.native="startUpload">Start upload</v-btn>
                </p>
              </v-stepper-content>

              <v-stepper-content step="3">
                <v-alert type="error" :value="!!error">
                  {{error}}
                </v-alert>
                <v-alert type="success" :value="!error">
                  {{importEntity | capitalize}} successful imported
                </v-alert>

                <v-data-table
                  v-if="importEntity === 'customers' && !error"
                  :headers="customerHeaders"
                  :items="updated"
                  hide-default-footer
                  class="elevation-1">
                  <template slot="items" slot-scope="props">
                    <td>{{ props.item.customerID }}</td>
                    <td>{{ props.item.customerName1 }}</td>
                    <td>{{ props.item.customerName2 }}</td>
                    <td>{{ props.item.country }}</td>
                    <td>{{ props.item.city }}</td>
                    <td>{{ props.item.zipcode }}</td>
                    <td>{{ props.item.locationcode }}</td>
                  </template>
                </v-data-table>

                <v-data-table
                  v-if="importEntity === 'contacts' && !error"
                  :headers="contactHeaders"
                  :items="updated"
                  hide-default-footer
                  class="elevation-1">
                  <template slot="items" slot-scope="props">
                    <td>{{ props.item.contactId }}</td>
                    <td>{{ props.item.contactText1 }}</td>
                    <td>{{ props.item.contactText2 }}</td>
                    <td>{{ props.item.country }}</td>
                    <td>{{ props.item.city }}</td>
                    <td>{{ props.item.gepardCustomerNumber }}</td>
                    <td>{{ props.item.contactLocationCode }}</td>
                  </template>
                </v-data-table>

              </v-stepper-content>
            </v-stepper-items>
          </v-stepper>
        </v-card>
      </v-container>
  </v-flex>
</v-layout>
</template>


<script>
export default {
  data() {
    return {
      step: 1,
      importEntity: undefined,
      file: undefined,
      progress: 0,
      error: undefined,
      updated: [],
      customerHeaders: [
        { text: 'Customer ID', sortable: false },
        { text: 'Customer Name 1', sortable: false },
        { text: 'Customer Name 2', sortable: false },
        { text: 'Country', sortable: false },
        { text: 'Country', sortable: false },
        { text: 'Zip', sortable: false },
        { text: 'Location Code', sortable: false }
      ],
      contactHeaders: [
        { text: 'ID', sortable: false },
        { text: 'Text 1', sortable: false },
        { text: 'Text 2', sortable: false },
        { text: 'Country', sortable: false },
        { text: 'City', sortable: false },
        { text: 'Gepard Nr', sortable: false },
        { text: 'Location Code', sortable: false },
      ]
    }
  },

  methods: {
    chooseImportEntity(entity) {

      if (entity === 'customers' || entity === 'contacts') {
        this.importEntity = entity
        this.step = 2
      }
    },

    chooseFile($event) {
      if ($event.target.files.length) {
        this.file = $event.target.files[0]
        console.log(this.file)
      }
    },

    startUpload() {
      this.step = 3

      let importPromise

      if (this.importEntity === 'customers') {
        importPromise = this.dataService.importCustomer(this.file)
      } else if (this.importEntity === 'contacts') {
        importPromise = this.dataService.importContact(this.file)
      } else {
        importPromise = Promise.reject(
          'invalid importEntity selected: ' + this.importEntity
        )
      }

      importPromise
        .then(result => {
          console.log('DONE', result)
          this.updated = result.data.updated
        })
        .catch(err => {
          console.log('ERROR')
          if (err.response) {
            // got error response from server
            console.log(+err.response.data)
            this.error =
              'Error while importing data:' + err.response.data.message
          } else if (err.request) {
            // transport error
            console.log('error on import (transport):', err)
            this.error = 'Error while sending the request'
          } else {
            // error on setup
            console.log('error on import (setup):', err)
            this.error = 'Error while creating the import request: ' + err
          }
        })
    }
  }
}
</script>



// WEBPACK FOOTER //
// ImportContactsCustomer.vue?96f0f9ba